import {
  AuditOutlined,
  CheckSquareOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  FieldTimeOutlined,
  FlagOutlined,
  LockOutlined,
  MoonOutlined,
  ScheduleOutlined,
  SyncOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { Form } from 'antd';
import {
  Group,
  MasterSwitch,
  SettingNumber,
  SettingSwitch,
} from '@/components/profile/settingCards';
import { cn } from '@/libs/utils';
import { useCompanyGeneralDataForm } from '../CompanyGeneralDataFormContext';

// The "Time tracking and timesheet" tile as setting cards. Same fields and
// save as CompanyTimeSettings, which steps aside on the profile.

export default function CompanyTimeProfilePanel() {
  const {
    allowTimerKeys,
    attendanceModeKeys,
    autoSyncToPayrollKeys,
    defaultBillableKeys,
    lockAfterApprovalKeys,
    maxHoursPerDayKeys,
    readOnly,
    requireApprovalKeys,
    sectionClass,
    t,
    timeTrackingChecked,
    timeTrackingKeys,
    timeTrackingState,
    timesheetReviewEnabledChecked,
    timesheetReviewEnabledKeys,
    timesheetReviewEnabledState,
    timesheetReviewFlagNightKeys,
    timesheetReviewFlagOTKeys,
    timesheetReviewFlagPartialKeys,
    timesheetReviewFlagUnmarkedOtKeys,
    timesheetReviewMaxHoursKeys,
  } = useCompanyGeneralDataForm();
  const f = (key) => t(key, { ns: 'forms' });

  // The old block's inner switches had no permission state of their own.
  const toggle = (keys, props) => (
    <Form.Item name={keys} noStyle>
      <SettingSwitch locked={readOnly} {...props} />
    </Form.Item>
  );
  const hours = (keys) => (
    <Form.Item name={keys} noStyle>
      <SettingNumber
        locked={readOnly}
        icon={<ClockCircleOutlined />}
        title={f('maxHoursPerDay')}
        min={1}
        max={24}
      />
    </Form.Item>
  );

  return (
    <div className={cn('grid gap-4', sectionClass('vreme'))}>
      {timeTrackingState?.visible && (
        <div className="grid gap-3">
          <Form.Item name={timeTrackingKeys} noStyle>
            <MasterSwitch
              locked={readOnly || !!timeTrackingState?.disabled}
              icon={<FieldTimeOutlined />}
              title={f('timeTrackingPlatform')}
            />
          </Form.Item>
          {/* Mounted while switched off too, like the old block. */}
          <div className={cn(!timeTrackingChecked && 'hidden')}>
            <Group>
              {toggle(requireApprovalKeys, {
                icon: <CheckSquareOutlined />,
                title: f('requireApproval'),
              })}
              {toggle(lockAfterApprovalKeys, {
                icon: <LockOutlined />,
                title: f('lockAfterApproval'),
              })}
              {toggle(allowTimerKeys, {
                icon: <ClockCircleOutlined />,
                title: f('allowTimer'),
              })}
              {toggle(defaultBillableKeys, {
                icon: <DollarOutlined />,
                title: f('defaultBillable'),
              })}
              {toggle(autoSyncToPayrollKeys, {
                icon: <SyncOutlined />,
                title: f('autoSyncToPayroll'),
              })}
              {toggle(attendanceModeKeys, {
                icon: <TeamOutlined />,
                title: f('attendanceMode'),
                hint: f('attendanceModeTooltip'),
              })}
              {hours(maxHoursPerDayKeys)}
            </Group>
          </div>
        </div>
      )}

      {timesheetReviewEnabledState?.visible && (
        <div className="grid gap-3">
          <Form.Item name={timesheetReviewEnabledKeys} noStyle>
            <MasterSwitch
              locked={readOnly || !!timesheetReviewEnabledState?.disabled}
              icon={<ScheduleOutlined />}
              title={f('timesheetSettings')}
              desc={f('timesheetReviewDescription')}
            />
          </Form.Item>
          <div className={cn(!timesheetReviewEnabledChecked && 'hidden')}>
            <Group>
              {hours(timesheetReviewMaxHoursKeys)}
              {toggle(timesheetReviewFlagOTKeys, {
                icon: <FlagOutlined />,
                title: f('flagOTSameDayAsPublicHoliday'),
              })}
              {toggle(timesheetReviewFlagNightKeys, {
                icon: <MoonOutlined />,
                title: f('flagNightWithRegularEqFond'),
              })}
              {toggle(timesheetReviewFlagPartialKeys, {
                icon: <AuditOutlined />,
                title: f('flagPartialPublicHoliday'),
              })}
              {toggle(timesheetReviewFlagUnmarkedOtKeys, {
                icon: <FlagOutlined />,
                title: f('flagUnmarkedOvertime'),
              })}
            </Group>
          </div>
        </div>
      )}
    </div>
  );
}
